module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/images/wargods_shop_bg.a431e50f.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/images/wargods_shop_bg.jpg
// module id = 1320
// module chunks = 16